import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner3 from '../assets/banner3.jpg';
import { IoMdArrowDropright, IoMdCheckmarkCircleOutline, IoMdTrophy } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import { GiCheckMark } from "react-icons/gi";

export default function HomeBanner1(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner3, banner1, banner2, banner4, banner6];

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if (ready) {
		return (
			<div className="MainBodySection">
				<div
					style={{
						width: "100%",
						height: "calc(100vh - var(--topBarHeight))",
						position: "relative",
						overflow: "hidden"
					}}
				>

					{banners.map((banner, i) => (
						<div
							key={i}
							style={{
								backgroundImage: `url(${banner})`,
								backgroundAttachment: "fixed",
								backgroundSize: "cover",
								backgroundPosition: "center",
								width: "100%",
								height: "100%",
								position: "absolute",
								top: 0,
								left: 0,
								transition: "opacity 1.5s ease-in-out",
								opacity: i === bgIndex ? 1 : 0,
							}}
						/>
					))}

					{/* gradient overlay */}
					<div
						className="mDesktopOnly"
						style={{
							width: "40%",
							height: "100%",
							position: "relative",
							zIndex: 1,
							background: "#00356de5"
						}}
					>
						<div className="container">
							<div className="row">
								<div 
									className="col-12 px-5 pt-5"
								>
									<h1
										className="font-semi-bold text-light"
										data-aos="fade-right"
										style={{
											fontSize: "18px",
											paddingTop: "20px",
											textTransform: "uppercase",
										}}
									>
										ZAMANI SABIOS GROUP
									</h1>

									<h1
										className="font-bold text-light my-3" data-aos="fade-up"
										style={{
											fontSize: "32px",
											paddingTop: "10px",
											textTransform: "uppercase",
										}}
									>
										<span style={{fontSize: "48px"}}>250+ YEARS</span><br/> OF COMBINED<br/> PROFESSIONAL EXPERIENCE
									</h1>

									<h5 className="font-light text-light" data-aos="fade-up">
										Strengthening Public and Private Institutions through proven, Field-tested Expertise and Practical, Evidence-based solutions that drive sustainable growth.
									</h5>

									<div className="mt-5">

										<button
											className="p-0 bg-transparent border rounded"
											data-aos="zoom-in-up"
											style={{
												display: "flex",
												alignItems: "center",
												justifyContent: "space-between",
												overflow: "hidden"
											}}
											onClick={() => {
												appContext.navTo({
													item: 'contact_us'
												})
											}}
										>
											<h6 className="text-light font-semi-bold px-3 pt-2" >CONTACT US</h6>
											<div className="bg-light p-2"><IoMdArrowDropright className="text-secondary" size={32}/></div>
										</button>
									</div>

								</div>

								

							</div>
						</div>
					</div>

					<div
						className="mMobileOnly"
						style={{
							width: "100%",
							height: "100%",
							position: "relative",
							zIndex: 1,
							background: "#00356dcc"
						}}
					>
						<div className="container">
							<div className="row">
								<div 
									className="col-12 px-3 py-5"
								>
									<h1
										className="font-semi-bold text-light"
										data-aos="fade-right"
										style={{
											fontSize: "18px",
											paddingTop: "20px",
											textTransform: "uppercase",
										}}
									>
										ZAMANI SABIOS GROUP
									</h1>

									<h1
										className="font-bold text-light my-3" data-aos="fade-up"
										style={{
											fontSize: "32px",
											paddingTop: "10px",
											textTransform: "uppercase",
										}}
									>
										<span style={{fontSize: "48px"}}>250+ YEARS</span><br/> OF COMBINED<br/> PROFESSIONAL EXPERIENCE
									</h1>

									<h5 className="font-light text-light" data-aos="fade-up">
										Strengthening Public and Private Institutions through proven, Field-tested Expertise and Practical, Evidence-based solutions that drive sustainable growth.
									</h5>

									<div className="mt-5">

										<button
											className="p-0 bg-transparent border rounded"
											data-aos="zoom-in-up"
											style={{
												display: "flex",
												alignItems: "center",
												justifyContent: "space-between",
												overflow: "hidden"
											}}
											onClick={() => {
												appContext.navTo({
													item: 'contact_us'
												})
											}}
										>
											<h6 className="text-light font-semi-bold px-3 pt-2" >CONTACT US</h6>
											<div className="bg-light p-2"><IoMdArrowDropright className="text-secondary" size={32}/></div>
										</button>
									</div>

								</div>

								

							</div>
						</div>
					</div>

				</div>
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
